import React from 'react';
import { Link } from 'react-router-dom';
import { VotingInterface } from '../components/VotingInterface';
import { AdUnit } from '../components/AdUnit';

// Replace with your real AdSense slot ID from your AdSense dashboard
const AD_SLOT_HOME_BOTTOM = ''; // e.g. '9876543210'

export function HomePage() {
  return (
    <div>
      <h1 style={{ marginBottom: '8px' }}>Should I get reparations?</h1>
      <p className="home-description">
        Vote on whether you think this person deserves reparations.{' '}
        <Link to="/upload" style={{ color: '#28a745', fontWeight: '600' }}>
          Add your own photo →
        </Link>
      </p>

      <VotingInterface />

      {/* Bottom-of-page ad */}
      <AdUnit slot={AD_SLOT_HOME_BOTTOM} />

      <p
        style={{
          textAlign: 'center',
          color: '#aaa',
          fontSize: '0.8rem',
          marginTop: '40px',
          paddingBottom: '40px',
        }}
      >
        View the{' '}
        <Link to="/results" style={{ color: '#007bff' }}>
          full results →
        </Link>
      </p>
    </div>
  );
}
